  // EMULATE theme.js BEHAVIOUR AND OPEN LEVEL 3 MEGA NAV ON CLICK IF LEVEL 2 LINK EXISTS
  window.addEventListener("load", function() {
    const headerEl = document.querySelector('.header');
    const level3MegaNavElements = headerEl.querySelectorAll('.nav .nav__submenu.nav.nav--depth-2 .nav__item:first-of-type .nav__submenu.nav__meganav');

    level3MegaNavElements.forEach(level3MegaNavEl => {
      const level1Link = level3MegaNavEl.closest('li.nav__item.nav__item-parent.nav__item--depth-1')?.querySelector('a.nav__link.nav__link-parent');
      level1Link.addEventListener('click', function(e) {
        if(!e.target.nextElementSibling.classList.contains('visible')) return;
        const level2Link = e.target.nextElementSibling.querySelector('li:first-of-type a.nav__link.nav__link-parent');

        const mouseDownEvent = new MouseEvent('mousedown', {
            bubbles: true,           // Allows the event to bubble up
            cancelable: true,         // Allows the event to be canceled
            view: window,             // Specifies the view (usually `window`)
            button: 0                 // Indicates the primary (usually left) mouse button
        });

        // Dispatch the event
        level2Link.dispatchEvent(mouseDownEvent);
      });
    });

    // DETECT IF SCROLLED
    let isScrolled = false;
    let isAnimating = false; // New flag to prevent simultaneous animations
    const logoMainEl = headerEl.querySelector('.header__logo--main');
    const logoScrollEl = headerEl.querySelector('.header__logo--scroll');
    
    function handleScroll() {
      if (isAnimating) return; // Prevent running if an animation is in progress
      
      if (window.scrollY === 0 && isScrolled) {
        isScrolled = false;
        isAnimating = true;
        logoScrollEl.animate(
          [
            { opacity: 1 },
            { opacity: 0 }
          ],
          {
            duration: 300,
            easing: 'ease-in-out',
            fill: 'forwards'
          }
        ).finished.then(() => {
          logoScrollEl.style.display = 'none';
          logoScrollEl.style.opacity = 0;
          logoMainEl.style.display = 'block';
          logoMainEl.style.opacity = 0;
          return logoMainEl.animate(
            [
              { opacity: 0 },
              { opacity: 1 }
            ],
            {
              duration: 300,
              easing: 'ease-in-out',
              fill: 'forwards'
            }
          ).finished;
        }).then(() => {
          logoMainEl.style.opacity = 1;
          isAnimating = false;
        }).catch((error) => {
          console.error('Animation error:', error);
          isAnimating = false;
        });
      } else if (window.scrollY > 0 && !isScrolled) {
        isScrolled = true;
        isAnimating = true;
        logoMainEl.animate(
          [
            { opacity: 1 },
            { opacity: 0 }
          ],
          {
            duration: 300,
            easing: 'ease-in-out',
            fill: 'forwards'
          }
        ).finished.then(() => {
          logoMainEl.style.opacity = 0;
          logoScrollEl.style.display = 'block';
          logoScrollEl.style.opacity = 0;
          return logoScrollEl.animate(
            [
              { opacity: 0 },
              { opacity: 1 }
            ],
            {
              duration: 300,
              easing: 'ease-in-out',
              fill: 'forwards'
            }
          ).finished;
        }).then(() => {
          logoScrollEl.style.opacity = 1;
          isAnimating = false;
        }).catch((error) => {
          console.error('Animation error:', error);
          isAnimating = false;
        });
      }
    }
    
    function onScroll() {
      requestAnimationFrame(handleScroll);
    }
    
    if (logoScrollEl) {
      window.addEventListener('scroll', onScroll);
    }
    

    // QUICK SEARCH
    const searchInput = headerEl.querySelector('.header__icon-list .quick-search .search .search__container .search__input');
    const searchResultUnderlayEl = headerEl.querySelector('.header__icon-list .quick-search .search .search__container .search__result-container .search__result-underlay');
    const quickSearchContainerEl = headerEl.querySelector('.header__icon-list .quick-search');
    const quickSearchCloseEl = headerEl.querySelector('.header__icon-list .quick-search .search .search__container .search__input-close');

    let isTyping = false;

    searchInput.addEventListener('input', (event) => {
      const value = event.target.value;

      // Check if typing has started
      if (value.length > 0 && !isTyping) {
        isTyping = true;
        quickSearchCloseEl.setAttribute("aria-expanded", true);
        quickSearchContainerEl.classList.add('is-active');
      }

      // Check if input is empty
      if (value.length === 0 && isTyping) {
        isTyping = false;
        quickSearchContainerEl.classList.remove('is-active');
      }
    });

    searchResultUnderlayEl.addEventListener("click", function() {
      quickSearchCloseEl.setAttribute("aria-expanded", false);
      quickSearchContainerEl.classList.remove('is-active');
      searchInput.value = '';
      const inputEvent = new Event('input', {
        bubbles: true,
        cancelable: true
      });
      searchInput.dispatchEvent(inputEvent);
    });

    quickSearchCloseEl.addEventListener("click", function() {
      quickSearchCloseEl.setAttribute("aria-expanded", false);
      quickSearchContainerEl.classList.remove('is-active');
      searchInput.value = '';
      const inputEvent = new Event('input', {
        bubbles: true,
        cancelable: true
      });
      searchInput.dispatchEvent(inputEvent);
    });

    // MOBILE HEADER QUICK SEARCH SUPPORT
    const tabletMediaQuery = window.matchMedia('(max-width: 1024px)');
    const headerIconListEl = headerEl.querySelector('.header__icon-list');
    const mobileQuickSearchEl = headerEl.querySelector('#mobile-quick-search');
    const mobileQuickSearchNoJavascriptEl = headerEl.querySelector('#mobile-quick-search-no-js');

    let headerIconListClone = null;
    let searchIconEl = null;
    let searchIconIndex = null;

    function handleTabletChange(e) {
      if (e.matches) {
        // Clone headerIconListEl and append it to mobileQuickSearchEl
        headerIconListClone = headerIconListEl.cloneNode(true);
        headerIconListClone.innerHTML = '';
        mobileQuickSearchEl.appendChild(headerIconListClone);

        // Hide the non-JS quick search element
        mobileQuickSearchNoJavascriptEl.style.display = 'none';

        // Store the search icon element and its original index
        searchIconEl = headerIconListEl.querySelector('.header__icon.header__icon--search');
        if (searchIconEl) {
          searchIconIndex = Array.from(headerIconListEl.children).indexOf(searchIconEl);
          headerIconListClone.appendChild(searchIconEl); // Move search icon to the cloned list
        }
      } else {
        // Restore the search icon to its original position in headerIconListEl
        if (searchIconEl && searchIconIndex !== null) {
          headerIconListEl.insertBefore(searchIconEl, headerIconListEl.children[searchIconIndex]);
        }

        // Remove the cloned element from mobileQuickSearchEl
        if (headerIconListClone) {
          mobileQuickSearchEl.removeChild(headerIconListClone);
          headerIconListClone = null;
        }

        // Show the non-JS quick search element again
        mobileQuickSearchNoJavascriptEl.style.display = '';
      }
    }

    // Run on initial load
    handleTabletChange(tabletMediaQuery);

    // Listen for changes
    tabletMediaQuery.addEventListener('change', handleTabletChange);

    // HEADER MENU CLOSE
    const level2MenuElements = headerEl.querySelectorAll('.nav .nav__submenu.nav.nav--depth-2 .nav__submenu.nav__meganav');

    // Function to check each submenu's position and toggle the close button display
    function toggleCloseButtonVisibility(menu) {
      const menuRect = menu.getBoundingClientRect();
      const closeButton = menu.closest('.nav.nav--depth-2.nav__submenu').querySelector('.nav__close');
      
      if (menuRect.bottom >= window.innerHeight) {
        // If menu reaches the bottom of the viewport, show the close button
        closeButton.style.display = 'block';
      } else {
        // Otherwise, hide the close button
        closeButton.style.display = 'none';
      }
    }
    
    // Set up a MutationObserver to watch for the 'visible' class on each menu
    level2MenuElements.forEach(menu => {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class') {
            const isVisible = menu.classList.contains('visible');
            
            if (isVisible && !mutation.oldValue.includes('visible')) {
              // Run the function only when 'visible' is first added
              toggleCloseButtonVisibility(menu);
            }
          }
        });
      });
    
      // Start observing changes to the class attribute, and store the previous class state
      observer.observe(menu, { attributes: true, attributeOldValue: true });
    });
    
    const menuCloseButtonElements = headerEl.querySelectorAll('.nav .nav__submenu.nav.nav--depth-2 .nav__close');

    for (const btn of menuCloseButtonElements) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        document.body.click();
      });
    }

  })